import { BoxProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const styles = {
  container: {
    flex: 1,
    height: '100%',
    bg: 'WHITE',
  } as BoxProps,
  loaderContainer: {
    flex: 1,
    height: '100%',
    bg: 'WHITE',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  headerContainer: {
    paddingBottom: 25,
    paddingTop: 20,
    borderBottomWidth: 1,
    borderColor: 'SEPERATOR',
  } as BoxProps,
  btnContainer: {
    padding: 8,
    borderColor: 'GRAY_BORDER',
    borderWidth: 1,
    borderRadius: 4,
  } as BoxProps,
  listItemContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  closeIcon: {
    alignSelf: 'flex-end',
  } as BoxProps,
  greenContainer: {
    height: 54,
    width: 54,
    alignSelf: 'center',
    justify: 'center',
    align: 'center',
    borderRadius: 27,
  } as BoxProps,
  ruppeeText: {
    textAlign: 'center',
    fontSize: 28,
    letterSpacing: 1.4,
    fontWeight: 'bold',
  } as TextProps,
  contentContainerStyle: {
    paddingTop: 10,
    paddingHorizontal: 16,
    overflow: 'auto',
  } as ViewStyle,
  actionTab: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
    ph: 24,
    position: 'absolute',
    bottom: 24,
    left: 24,
    right: 24,
  } as BoxProps,
  actionWrapper: (showRightBorder: boolean) =>
    ({
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      paddingVertical: 16,
      borderRightWidth: showRightBorder ? 1 : 0,
      borderColor: 'SEPERATOR',
      alignItems: 'center',
      underlayColor: 'WHITE',
    } as BoxProps),
  actionText: {
    color: 'PRIMARY',
    fontFamily: 'JioType-Medium',
    fontWeight: '600',
    letterSpacing: -0.08,
  } as TextProps,
}

export default styles
